import type { Route } from "./+types/$locale._index";
import { buildSeoMeta } from "@/components/seo/meta";
import { Home } from "@/features/home";

/**
 * Home route (`/:locale/`).
 *
 * No loader: the home page's data sections (`<WhatYouCanRentSection>`,
 * `<WhereWeAreSection>`) fetch client-side via TanStack Query and render
 * nothing until data arrives, so the prerendered HTML stays static and the
 * page never depends on build-time catalogue/location snapshots.
 *
 * The `meta` export below is the source of truth for SEO tags on this page.
 */

export function meta({ params }: Route.MetaArgs) {
    const locale = (params.locale as string) ?? "en";
    return buildSeoMeta({
        title: "Baby Equipment Rentals — Strollers, Cribs & Car Seats",
        description:
            "Rent baby equipment by the day, week or month in Spain and Ireland. Clean, safety-checked car seats, strollers and travel cots, ready to collect for a holiday or for home.",
        path: "/",
        keywords:
            "baby equipment rental, stroller rental, crib rental, car seat rental, baby gear hire, travel baby equipment",
        // TODO Phase 6: hydrate availableLocales from root loader manifest
        locale,
        availableLocales: [{ code: "en" }],
    });
}

export default function HomeRoute() {
    return <Home />;
}
